import { useNavigate } from "react-router-dom";
import { EmptyState } from "../../components/empty";
export const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <EmptyState
        text="This event or page does not exist :("
        textClassName="!normal-case !font-normal !max-w-[300px]"
        subtext="The page you’re looking for could not be found or it has been (re)moved."
        subtextClassName="!max-w-[300px] !text-sm"
        ctaText="Go Home"
        ctaClassName="!max-w-[200px]"
        onCTAClick={() => {
          navigate("/");
        }}
        image="/assets/images/search-glass.png"
      />
    </div>
  );
};
